import moment from 'moment';
import React, { Component, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import './customReactDatepicker.css';
import './reports.css';
import ReportIcon from './../../../assets/img/mm/icon-13.png';
class MonthlyIncomeCashReport extends Component {
    constructor(props){
        super(props);
        this.state={
            date: props.reportDefaultDate || new Date(),
            data:[],
            userInfo: getLoginDistrictInfo(),
        }
    }
    bindData=()=>{
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const yearMonth=moment(this.state.date).format('YYYYMM');        
        let firstDay = moment(this.state.date).startOf('M').format('YYYY-MM-DD')+"T00:00:00";
        const lastDay=moment(this.state.date).endOf('M').format('YYYY-MM-DD')+"T23:59:59";
        let _url='';
        if(schoolID>0){
            _url='/reports/incomeCashReport/'+schoolID+'?isDistId=false&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")+
             '&yearMonth='+yearMonth+'&access_token=';
            }else{
                 _url='/reports/incomeCashReport/'+districtID+'?isDistId=true&startDate=' + moment(firstDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
             '&yearMonth='+yearMonth+'&access_token=';
            }
        this.setState({loading: true})
        get(_url).then((response) => {
            if (!response.ok) {
                if(response.status===417|| response.status===422){
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if(res.statusCode===417){
                _addNotificationError(res.statusMessage,this.props)
                    throw Error(res.errorMessage);
                }else if(res.statusCode===422){
                    throw Error(res.statusMessage);
                }else{
                    return res.blob();                
                } 
        }).then(blob => {
            let filename = "MonthlyIncomeCashReport";
            showFile(blob,filename);            
                this.setState({loading: false})
            }).catch((error) => {
                let msg=''
                if(typeof error==='string'){
                    msg=error;
                }else{
                    msg=error.message;
                }
                _addNotificationError(msg,this.props);
                this.setState({loading: false})
            }
        );
    }
    render() {
        const {date,mealType}=this.state;
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">  
                                <img src={ReportIcon} />                                                  
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Monthly Income Cash Report</b></span>                                                    
                                </div>
                            </div>                                            
                        <div className="reportCard-widget-meeting-points">
                            <div className="row form-group">
                                <label class="col-sm-12 control-label">Month</label>
                                <div className="col-sm-12 ">
                                    <DatePicker wrapperClassName="fullWidthDatepicker"                               
                                        selected={date}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                        onChange={(date) => {
                                            this.setState({date:date});
                                        }} className='form-control form-control-sm' />
                                </div>
                            </div>
                        </div>
                        <div className='reportCard-widget-meeting-action'>
                            <div className="form-group"> 
                                <button type='button' className='btn btn-sm btn-success' style={{margin:'0px'}} onClick={()=>{
                                    this.bindData()
                                }}>
                                    Download Report
                                </button>
                            </div>                            
                        </div>
                    </div>
                </div>
                </div>
            </Fragment>
        );
    }
}

export default MonthlyIncomeCashReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/monthlyIncomeCashReport.js